import { RoomEvent, Room } from 'matrix-js-sdk';
import { Log } from '@fanfanlo';
import { roomService } from '../roomService';
import { matrixClient } from '../../client';

const fileLogger = new Log(false, 'im.client.room.handlers.roomName');
fileLogger.childrenPaused = true;
function onRoomNameChanged(room: Room) {
    const logger = fileLogger.sub(false, 'onRoomNameChanged');
    logger.pause = true;
    const roomId = room.roomId;
    logger.log(`Room name changed: ${room.name} (${roomId})`);

    // 更新房间名称和头像URL
    const client = matrixClient.client;
    const avatarUrl = room.getAvatarUrl(client.getHomeserverUrl(), 32, 32, 'scale', false, false) || undefined;
    
    roomService.addOrUpdateRoomInfo({
        roomId,
        name: room.name,
        avatarUrl
    });
}

export const roomNameHandler = {
    init() {
        matrixClient.clientOnEventDispatcher.addListener(RoomEvent.Name, onRoomNameChanged);
    }
};
